module.exports = __webpack_public_path__ + "public/img/05.4f5ecc3e.png";